"use client";

import { useState, useEffect } from "react";
import { Code, Palette, Bot, Settings, ArrowUpRight } from "lucide-react";

const cards = [
  {
    id: "web-dev",
    title: "Web Development",
    description:
      "We use latest MERN stack (MongoDB, Express, React, Node.js) technology to build fast, secure and scalable websites tailored to your needs.",
    image:
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1400&q=85",
    Icon: Code,
  },
  {
    id: "uiux",
    title: "UI/UX Services",
    description:
      "We design modern, responsive and conversion-focused websites, apps, and dashboards with user-friendly experiences.",
    image:
      "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=1400&q=85",
    Icon: Palette,
  },
  {
    id: "ai",
    title: "AI Chatbot",
    description:
      "We build custom AI chatbots that answer queries, support users, and automate communication 24/7 using your data.",
    image:
      "https://images.unsplash.com/photo-1677691820099-a6e8040aa077?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    Icon: Bot,
  },
  {
    id: "support",
    title: "Maintenance & Support",
    description:
      "We provide ongoing maintenance, updates, security monitoring, and technical support for smooth performance.",
    image:
      "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?w=1400&q=85",
    Icon: Settings,
  },
];

export const OwnServices = () => {
  const [active, setActive] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <main
      onClick={() => window.open("https://www.broshtech.com/contact", "_blank")}
      style={{
        background: "#fafafa",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "60px 20px" : "clamp(40px,7vh,100px) clamp(16px,3vw,100px)",
      }}
    >
      <section
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? "24px" : "clamp(20px, 2vw, 32px)",
          width: "100%",
          maxWidth: "2300px",
          alignItems: "stretch",
        }}
      >
        {/* LEFT */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "18px",
          }}
        >
          {cards.map((card, index) => {
            const isActive = active === index;

            return (
              <div
                key={card.id}
                onMouseEnter={() => !isMobile && setActive(index)}
                onClick={() => isMobile && setActive(index)}
                style={{
                  position: "relative",
                  padding: isMobile ? "24px" : "clamp(32px, 2.5vw, 44px)",
                  borderRadius: "18px",
                  cursor: "pointer",
                  background: isActive ? "#111" : "#fafafa",
                  color: isActive ? "#fff" : "#111",
                  border: "1px solid rgba(0,0,0,0.08)",
                  transition: "0.35s",
                  display: "flex",
                  flexDirection: "column",
                  minHeight: isMobile ? "180px" : "clamp(200px, 15vh, 260px)",
                  justifyContent: "flex-start",
                }}
              >
                {/* TITLE LEFT */}
                <h2
                  style={{
                    margin: "0 0 10px",
                    fontSize: isMobile ? "24px" : "clamp(26px, 1.8vw, 36px)",
                    fontWeight: 900,
                    maxWidth: "100%",
                  }}
                >
                  {card.title}
                </h2>

                {/* DESCRIPTION */}
                <p
                  style={{
                    margin: 0,
                    fontSize: isMobile ? "13px" : "clamp(14px, 1.2vw, 16px)",
                    opacity: isActive ? 0.9 : 0.7,
                    maxWidth: "100%",
                    lineHeight: "1.6",
                    marginBottom: "40px"
                  }}
                >
                  {card.description}
                </p>

                {/* ICON BOTTOM RIGHT */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "24px",
                    right: "24px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    opacity: isActive ? 1 : 0,
                    transform: isActive ? "translateY(0)" : "translateY(10px)",
                    transition: "all 0.3s ease",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
Start Your Project with Broshtech                  </span>

                  <ArrowUpRight
                    size={isMobile ? 28 : 32}
                    color="white"
                  />
                </div>
              </div>
            );
          })}
        </div>

        {/* RIGHT IMAGE */}
        <div
          style={{
            flex: 1.2,
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
            height: isMobile ? "300px" : "auto",
          }}
        >
          <img
            src={cards[active].image}
            alt="service"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "0.5s ease",
            }}
          />
        </div>
      </section>
    </main>
  );
};

export default OwnServices;